import { defineStore } from "pinia";

export const useCatalogPublicationAuthorsStore = defineStore("CatalogPublicationAuthorsStore", {
  state: () => ({
    data: null,
    loading: false,
  }),
  actions: {
    async fetchCatalogPublicationAuthors(query) {
      this.loading = true;
      try {
        const response = await this.$axios.get('/api/v1/catalog/authors', { params: { query } });
        this.data = response.data;
      } catch (error) {
        console.error('Error fetching data:', error);
      }
      this.loading = false;
    },
    async fetchAuthor(id) {
      try {
        const response = await this.$axios.get(`/api/v1/catalog/author/${id}`);
        return response.data;
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
  }
});
